import { render, staticRenderFns } from "./changeStaffPassword.vue?vue&type=template&id=27d34d59&scoped=true&"
import script from "./changeStaffPassword.vue?vue&type=script&lang=js&"
export * from "./changeStaffPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d34d59",
  null
  
)

export default component.exports